function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Flex, getPaletteColor, borderRadiusAttrs } from 'pcln-design-system';
import { borderRadius } from 'styled-system';
import { Check as CheckIcon } from 'pcln-icons';
const MenuButton = styled(Button).attrs(borderRadiusAttrs).withConfig({
  displayName: "MenuItem__MenuButton",
  componentId: "sc-1cw9s2i-0"
})(["background-color:", ";border:2px solid transparent;color:", ";outline:none;padding:12px;> ", "{justify-content:space-between;}&:hover{", "}&:hover ", "{color:", ";}", ";"], props => props.selected ? getPaletteColor('light')(props) : getPaletteColor('background.lightest')(props), getPaletteColor('text.base'), Flex, props => props.selected ? `
        background-color: ${getPaletteColor('light')(props)};
        color: ${getPaletteColor('dark')(props)};` : `
        background-color: ${getPaletteColor('background.base')(props)};
        color: ${getPaletteColor('text.base')(props)};
      `, CheckIcon, getPaletteColor('dark'), borderRadius);
const MenuItem = /*#__PURE__*/React.forwardRef(function MenuItem(_ref, ref) {
  let {
    id,
    color,
    icon,
    selected,
    children,
    handleClose,
    onClick,
    ...props
  } = _ref;
  const handleClick = useCallback(() => {
    onClick && onClick();
    handleClose && handleClose();
  }, [onClick, handleClose]);
  return /*#__PURE__*/React.createElement(MenuButton, _extends({
    id: id,
    "aria-selected": selected,
    borderRadius: "lg",
    color: color,
    onClick: handleClick,
    ref: ref,
    role: "option",
    selected: selected
  }, props), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "center"
  }, icon && /*#__PURE__*/React.createElement(Flex, {
    mr: 3
  }, icon), children), selected && /*#__PURE__*/React.createElement(CheckIcon, {
    title: "check",
    size: 20,
    ml: 3,
    color: color
  }));
});
MenuItem.displayName = 'MenuItem';
MenuItem.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.node,
  color: PropTypes.string,
  selected: PropTypes.bool,
  children: PropTypes.node,
  handleClose: PropTypes.func,
  onClick: PropTypes.func
};
MenuItem.defaultProps = {
  color: 'primary'
};
export default /*#__PURE__*/memo(MenuItem);